import { unavailableFeatureTypes } from './actionTypes'
import {
    UnavailableFeaturePopupActions,
    UnavailableFeatureState,
} from './types'

const initialState: UnavailableFeatureState = {
    isVisible: false,
}

export default (
    state = initialState,
    action: UnavailableFeaturePopupActions,
) => {
    switch (action.type) {
        case unavailableFeatureTypes.SHOW_UNAVAILABLE_FEATURE_POPUP:
            return {
                ...state,
                isVisible: true,
            }
        case unavailableFeatureTypes.HIDE_UNAVAILABLE_FEATURE_POPUP:
            return initialState
        default:
            return {
                ...state,
            }
    }
}
